import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { getConsolidatedParkingData } from "modules/noc/services/parkingService";
import { filterParking, parkingStats } from "../model/parkingModel";
const initialFilters = {
  busqueda: "",
  tipoComercio: "todos",
  estado: "todos",
  estadoCiclos: "todos",
};
export const useParking = () => {
  const [todosComercios, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [warning, setWarning] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [filtros, setFilters] = useState(initialFilters);
  const mounted = useRef(false),
    pending = useRef(null),
    revision = useRef(0);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      revision.current++;
    };
  }, []);
  const refreshData = useCallback(async () => {
    const id = ++revision.current;
    setLoading(true);
    setError(null);
    if (!pending.current) {
      pending.current = getConsolidatedParkingData();
      const promise = pending.current;
      promise
        .finally(() => {
          if (pending.current === promise) pending.current = null;
        })
        .catch(() => {});
    }
    try {
      const result = await pending.current;
      if (!mounted.current || revision.current !== id) return { success: false };
      if (!result.success) throw new Error(result.error || "No se pudieron cargar los comercios");
      setRows(result.data);
      setWarning(result.warning || null);
      setLastUpdated(new Date().toISOString());
      return { success: true, warning: result.warning || null };
    } catch (err) {
      if (mounted.current && revision.current === id) setError(err.message);
      return { success: false, error: err.message };
    } finally {
      if (mounted.current && revision.current === id) setLoading(false);
    }
  }, []);
  useEffect(() => {
    refreshData();
  }, [refreshData]);
  const comercios = useMemo(
    () => filterParking(todosComercios, filtros),
    [todosComercios, filtros]
  );
  const stats = useMemo(() => parkingStats(comercios), [comercios]);
  const tiposComercioUnicos = useMemo(
    () =>
      [
        ...new Set(
          todosComercios.map((r) => r.tipo_comercio).filter((v) => v !== "No especificado")
        ),
      ].sort(),
    [todosComercios]
  );
  const setFiltro = useCallback(
    (key, value) => setFilters((previous) => ({ ...previous, [key]: value })),
    []
  );
  const clearFilters = useCallback(() => setFilters(initialFilters), []);
  return {
    comercios,
    todosComercios,
    loading,
    isLoading: loading,
    error,
    warning,
    lastUpdated,
    stats,
    filtros,
    tiposComercioUnicos,
    refreshData,
    setFiltro,
    clearFilters,
  };
};
